"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPosaCode = exports.isCoupon = void 0;
// Coupon codes are six charcter strings and redeem codes are codes less then 20 chars.
const isCoupon = code => {
    if (!code)
        return false;
    const couponCode = /[a-zA-Z-]/g;
    const isSpecialCodeLength = [6, 15, 13].indexOf(code.length) >= 0;
    if (isSpecialCodeLength && couponCode.test(code))
        return true;
    return code.length >= 20;
};
exports.isCoupon = isCoupon;
/**
 * Check Code Client Side if code looks like a VBucks Card Code and not Redeem Code
 */
const isPosaCode = currentValue => {
    // checks to make sure length matches for posa codes
    const cvLength = currentValue.length;
    // String Coupon codes are six characters long.
    if (cvLength === 6)
        return false;
    const checkLength = cvLength >= 16 && cvLength <= 19;
    const withoutDashes = /[a-zA-Z0-9]{16}/g;
    const withDashes = /[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-ZZ0-9]{4}/g;
    return (withoutDashes.test(currentValue) || withDashes.test(currentValue)) && checkLength;
};
exports.isPosaCode = isPosaCode;
//# sourceMappingURL=util.js.map